import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { routes } from './reports.routes';
import { ReportsComponent } from './reports.component';
import { ReportsService } from './reports.service';
import { BrowserModule } from '@angular/platform-browser';
import { AppService } from '../app.service';
import { SharedModule } from '../shared/shared.module';
import { ClearanceItemCommonModule } from '../clearance-item/clearance-item-common.module';
import { FileDownloadService } from '../shared/helper-components/file-download.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TextFieldModule } from '@angular/cdk/text-field';
import { ReportsStatusDialogComponent } from './reports.component';

@NgModule({
  declarations: [
    /**
     * Components / Directives/ Pipes
     */
    ReportsComponent,
    ReportsStatusDialogComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule.forRoot(),
    RouterModule.forChild(routes),
    ClearanceItemCommonModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatSlideToggleModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatExpansionModule,
    MatProgressBarModule,
    MatDialogModule,
    MatButtonModule,
    TextFieldModule
  ],
  providers: [
    ReportsService,
    FileDownloadService
  ]
})
export class ReportsModule {
  public static routes = routes;
}